import { Eye, EyeClosed } from 'lucide-react';

interface VisibilityToggleButtonProps {
  /** Whether the layer this button controls is currently shown. */
  visible: boolean;
  /** Accessible name — every row words it differently, so the caller owns the copy. */
  label: string;
  /** Called when the user flips visibility; the caller decides what to flip. */
  onToggle: () => void;
}

/**
 * Eye / closed-eye button that shows or hides a map layer. Always visible: hiding a layer is a
 * primary affordance of these sections, and behind a hover reveal it was undiscoverable — nothing
 * on the row said the eye was there to find.
 */
export function VisibilityToggleButton({ visible, label, onToggle }: VisibilityToggleButtonProps) {
  return (
    <button
      type="button"
      aria-pressed={visible}
      aria-label={label}
      onClick={(e) => {
        // Some rows are clickable containers of their own; the eye must not bubble into them.
        e.stopPropagation();
        onToggle();
      }}
      className="p-1 rounded-sm hover:bg-accent"
    >
      {visible ? <Eye className="size-4" /> : <EyeClosed className="size-4" />}
    </button>
  );
}
